export default __webpack_public_path__ + "static/media/bathymetryThumb.4347789e.png";